import React from 'react'

export default function Post({ node })
{
    const { title, date } = node.frontmatter
    return (
        <article>
            <header>
                <h2 className="article-title">
                    {title}
                </h2>
                <p className="article-date">
                    {date}
                </p>
            </header>
            <section
                className="markdown"
                dangerouslySetInnerHTML={{ __html: node.html }} />

        </article>
    )
}
